export default "__VITE_ASSET__BfJrBh2w__"